import { supabase } from "./supabase";
import type { SectionName } from "@klubora/shared";

export interface WriteTenantSettingResponse {
  merged: Record<string, unknown>;
  persistedKeys: string[];
  deletedKeys: string[];
}

export async function writeTenantSetting(
  tenantId: string,
  section: SectionName,
  values: Record<string, unknown>,
  options?: { publish?: boolean },
): Promise<WriteTenantSettingResponse> {
  const body: {
    tenantId: string;
    section: SectionName;
    values: Record<string, unknown>;
    publish?: boolean;
  } = { tenantId, section, values };
  // Absent flag is the welcome path. Explicit false is the refuse that can
  // freeze the pre-edit merge; explicit true publishes.
  if (typeof options?.publish === "boolean") body.publish = options.publish;

  const { data, error } = await supabase.functions.invoke<WriteTenantSettingResponse>(
    "write-tenant-setting",
    { body },
  );
  if (error) {
    throw new Error(`write-tenant-setting failed: ${error.message}`);
  }
  if (!data) {
    throw new Error("write-tenant-setting returned empty body");
  }
  return data;
}
